if(customElements.get("simple-slider") === undefined) {
  class SimpleSlider extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.slidesPerView = this.getAttribute('slides-per-view') || 1;
      this.loop = this.getAttribute('loop') ? false : true;

      this.thumbnails = this.getAttribute('thumbnails');
      this.pagination = this.getAttribute('pagination');
      this.direction = this.getAttribute('direction') || 'horizontal';

      this.options = {
        // default options
        loop: this.loop,
        pagination: this.pagination ? {
          el: '.swiper-pagination',
          clickable: true
        } : false,
        thumbs: this.thumbnails ? {
          swiper: this.thumbnails
        } : false,
        direction: this.direction,
        watchSlidesVisibility: this.thumbnails ? true : false,
        watchSlidesProgress: this.thumbnails ? true : false,
        slidesPerView: Number(this.slidesPerView),
        loopAddBlankSlides: false,
        spaceBetween: this.getAttribute('spaceBetween') || 0
      };
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      // destroy swiper slider when custom element is removed from DOM
      this.swiper.destroy();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') return;
      // create swiper container and wrapper elements
      const container = document.createElement('div');
      container.classList.add('swiper-container');
      const wrapper = document.createElement('div');
      wrapper.classList.add('swiper-wrapper');

      // add slides to wrapper element
      const slides = this.querySelectorAll('[data-slide]');
      slides.forEach((slide) => {
        slide.classList.add('swiper-slide');
        wrapper.appendChild(slide);
      });

      // append container and wrapper elements to custom element
      container.appendChild(wrapper);

      if(this.pagination) {
        const pagination = document.createElement('div');
        pagination.classList.add('swiper-pagination');
        container.appendChild(pagination);
      }
      
      this.appendChild(container);
      // initialize swiper slider
      this.swiper = new Swiper(container, this.options);
    }

  }

  customElements.define('simple-slider', SimpleSlider);
}